// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.marketplace-panel table td.travel {
    padding: 0 20px;
}

.marketplace-panel table td {
    vertical-align: top;
}

.marketplace-panel .waypoint img {
    float: left;
}

.marketplace-panel .waypoint p {
    padding-left: 40px;
}

.marketplace-panel h3, .marketplace-panel h4 {
    padding-top: 10px;
    padding-bottom: 0;
    margin-bottom: 0;
}

.marketplace-panel table {
    width: 100%;
    border-collapse: collapse;
}

.marketplace-panel table.split-70-30 .first-cell {
    width: 70%
}

.marketplace-panel table.split-70-30 .second-cell {
    width: 30%
}


.marketplace-panel table.split-33 .first-cell,
.marketplace-panel table.split-33 .second-cell,
.marketplace-panel table.split-33 .third-cell {
    width: 33%
}


.marketplace-panel .freight-table td {
    padding: 5px;
}`, "",{"version":3,"sources":["webpack://./routes/app/routes/marketplace/MarketplacePanels.css"],"names":[],"mappings":";;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;AAGA;;;IAGI;AACJ;;;AAGA;IACI,YAAY;AAChB","sourcesContent":["\n\n.marketplace-panel table td.travel {\n    padding: 0 20px;\n}\n\n.marketplace-panel table td {\n    vertical-align: top;\n}\n\n.marketplace-panel .waypoint img {\n    float: left;\n}\n\n.marketplace-panel .waypoint p {\n    padding-left: 40px;\n}\n\n.marketplace-panel h3, .marketplace-panel h4 {\n    padding-top: 10px;\n    padding-bottom: 0;\n    margin-bottom: 0;\n}\n\n.marketplace-panel table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.marketplace-panel table.split-70-30 .first-cell {\n    width: 70%\n}\n\n.marketplace-panel table.split-70-30 .second-cell {\n    width: 30%\n}\n\n\n.marketplace-panel table.split-33 .first-cell,\n.marketplace-panel table.split-33 .second-cell,\n.marketplace-panel table.split-33 .third-cell {\n    width: 33%\n}\n\n\n.marketplace-panel .freight-table td {\n    padding: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
